import React from "react";
import { Link } from "react-router-dom";
import DiamondMark from "@/components/DiamondMark";
import { useSite } from "@/context/SiteContext";

export default function Footer() {
  const { settings } = useSite();
  const year = new Date().getFullYear();

  return (
    <footer data-testid="public-footer" className="bg-bd-black text-bd-ivory border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-5">
              <DiamondMark size={32} />
              <span className="font-serif text-xl">Black Diamond</span>
            </div>
            <p className="text-sm text-bd-ivory/60 leading-relaxed max-w-xs">
              {settings.company_name || "Black Diamond Ventures Group Ltd"}
            </p>
            <p className="text-xs text-bd-ivory/40 mt-2">Company No. {settings.company_no || "17369044"}</p>
            {settings.registered_office ? (
              <p className="text-xs text-bd-ivory/40 mt-2">{settings.registered_office}</p>
            ) : null}
          </div>

          <div>
            <h4 className="overline text-bd-gold mb-5">Group</h4>
            <ul className="space-y-3 text-sm text-bd-ivory/70">
              <li><Link to="/ventures" className="hover:text-bd-gold transition-colors">Ventures</Link></li>
              <li><Link to="/services" className="hover:text-bd-gold transition-colors">Group Capabilities</Link></li>
              <li><Link to="/about" className="hover:text-bd-gold transition-colors">About</Link></li>
              <li><Link to="/insights" className="hover:text-bd-gold transition-colors">Insights</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="overline text-bd-gold mb-5">Engage</h4>
            <ul className="space-y-3 text-sm text-bd-ivory/70">
              <li><Link to="/partnerships" className="hover:text-bd-gold transition-colors">Partnerships</Link></li>
              <li><Link to="/acquisitions" className="hover:text-bd-gold transition-colors">Acquisitions</Link></li>
              <li><Link to="/contact" className="hover:text-bd-gold transition-colors">Contact</Link></li>
              {settings.contact_email ? (
                <li><a href={`mailto:${settings.contact_email}`} className="hover:text-bd-gold transition-colors">{settings.contact_email}</a></li>
              ) : null}
            </ul>
          </div>

          <div>
            <h4 className="overline text-bd-gold mb-5">Legal</h4>
            <ul className="space-y-3 text-sm text-bd-ivory/70">
              <li><Link to="/legal/privacy" className="hover:text-bd-gold transition-colors">Privacy</Link></li>
              <li><Link to="/legal/cookies" className="hover:text-bd-gold transition-colors">Cookies</Link></li>
              <li><Link to="/legal/terms" className="hover:text-bd-gold transition-colors">Terms</Link></li>
              <li><Link to="/legal/accessibility" className="hover:text-bd-gold transition-colors">Accessibility</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs text-bd-ivory/40">
            © {year} {settings.company_name || "Black Diamond Ventures Group Ltd"}. All rights reserved.
          </p>
          <Link to="/login" data-testid="footer-portal-link" className="text-xs text-bd-ivory/40 hover:text-bd-gold transition-colors tracking-wide">
            Group Portal
          </Link>
        </div>
      </div>
    </footer>
  );
}
